import React from 'react';

const Team = () => (
  <section id="team" className="g-bg-secondary g-pt-75 g-pb-45">
    <div className="container">
      {/* Section Heading */}
      <div className="row g-mb-30">
        <div className="col-12 text-center">
          <h2 className="h4 g-color-white g-font-weight-600 text-uppercase g-mb-5">
            Our Leadership & Team
          </h2>
          <p className="g-color-white-opacity-0_8 g-font-size-13 mb-0">
            Serving God by serving His people.
          </p>
        </div>
      </div>

      <div className="row">
        {/* Brown Family */}
        <div className="col-lg-3 col-sm-6 g-mb-30">
          <div className="u-info-v6-1">
            <figure className="u-block-hover">
              <img
                className="w-100"
                src="/images/IMG_4282.jpeg"
                height={255}
                width={255}
                alt="The Brown family"
              />
              <figcaption className="u-block-hover__additional--fade g-bg-primary-opacity-0_9 g-pa-30">
                <div className="u-block-hover__additional--fade u-block-hover__additional--fade-down g-flex-middle">
                  <ul className="list-inline text-center g-flex-middle-item">
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-twitter" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </figcaption>
            </figure>
            <div className="g-bg-white g-pa-25">
              <div className="g-mb-15">
                <h4 className="h5 g-color-black g-mb-5">The Brown Family</h4>
                <em className="d-block u-info-v6-1__item g-font-style-normal g-font-size-11 text-uppercase g-color-primary">
                  Family & Legacy
                </em>
              </div>
              <ul className="list-unstyled g-color-gray-dark-v5 g-font-size-12">
                <li>
                  <strong>E-mail:</strong> info@bishopkjbrown.org
                </li>
                <li>
                  <strong>Phone:</strong> +1 (832) 246-5377
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bishop & First Lady */}
        <div className="col-lg-3 col-sm-6 g-mb-30">
          <div className="u-info-v6-1">
            <figure className="u-block-hover">
              <img
                className="w-100"
                src="/images/together.jpg"
                height={255}
                width={255}
                alt="Bishop K.J. Brown and Lady Priscilla Guillory Brown"
              />
              <figcaption className="u-block-hover__additional--fade g-bg-primary-opacity-0_9 g-pa-30">
                <div className="u-block-hover__additional--fade u-block-hover__additional--fade-down g-flex-middle">
                  <ul className="list-inline text-center g-flex-middle-item">
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-twitter" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </figcaption>
            </figure>
            <div className="g-bg-white g-pa-25">
              <div className="g-mb-15">
                <h4 className="h5 g-color-black g-mb-5">
                  Bishop K.J. &amp; Lady Priscilla Guillory Brown
                </h4>
                <em className="d-block u-info-v6-1__item g-font-style-normal g-font-size-11 text-uppercase g-color-primary">
                  Bishop &amp; First Lady
                </em>
              </div>
              <ul className="list-unstyled g-color-gray-dark-v5 g-font-size-12">
                <li>
                  <strong>E-mail:</strong> bishop@bishopkjbrown.org
                </li>
                <li>
                  <strong>Phone:</strong> +1 (832) 246-5377
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Pastor Simmons */}
        <div className="col-lg-3 col-sm-6 g-mb-30">
          <div className="u-info-v6-1">
            <figure className="u-block-hover">
              <img
                className="w-100"
                src="/images/pastor.jpg"
                height={255}
                width={255}
                alt='Pastor L. E. "StoryTeller" Simmons'
              />
              <figcaption className="u-block-hover__additional--fade g-bg-primary-opacity-0_9 g-pa-30">
                <div className="u-block-hover__additional--fade u-block-hover__additional--fade-down g-flex-middle">
                  <ul className="list-inline text-center g-flex-middle-item">
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-twitter" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </figcaption>
            </figure>
            <div className="g-bg-white g-pa-25">
              <div className="g-mb-15">
                <h4 className="h5 g-color-black g-mb-5">
                  Pastor L. E. &quot;StoryTeller&quot; Simmons
                </h4>
                <em className="d-block u-info-v6-1__item g-font-style-normal g-font-size-11 text-uppercase g-color-primary">
                  Pastor
                </em>
              </div>
              <ul className="list-unstyled g-color-gray-dark-v5 g-font-size-12">
                <li>
                  <strong>E-mail:</strong>{' '}
                  pastorle_simmons@bishopkjbrown.org
                </li>
                <li>
                  <strong>Phone:</strong> (Available upon request)
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Antonio */}
        <div className="col-lg-3 col-sm-6 g-mb-30">
          <div className="u-info-v6-1">
            <figure className="u-block-hover">
              <img
                className="w-100"
                src="/images/IMG_1506.jpg"
                height={255}
                width={255}
                alt="Antonio M. Dotson"
              />
              <figcaption className="u-block-hover__additional--fade g-bg-primary-opacity-0_9 g-pa-30">
                <div className="u-block-hover__additional--fade u-block-hover__additional--fade-down g-flex-middle">
                  <ul className="list-inline text-center g-flex-middle-item">
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-twitter" />
                      </a>
                    </li>
                    <li className="list-inline-item align-middle g-mx-3">
                      <a
                        className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-black--hover g-brd-white g-bg-white--hover rounded-circle"
                        href="#"
                      >
                        <i className="fa fa-linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </figcaption>
            </figure>
            <div className="g-bg-white g-pa-25">
              <div className="g-mb-15">
                <h4 className="h5 g-color-black g-mb-5">Antonio M. Dotson</h4>
                <em className="d-block u-info-v6-1__item g-font-style-normal g-font-size-11 text-uppercase g-color-primary">
                  Ministry of Communications &amp; Media
                </em>
              </div>
              <ul className="list-unstyled g-color-gray-dark-v5 g-font-size-12">
                <li>
                  <strong>E-mail:</strong> antonio@mypenmail.com
                </li>
                <li>
                  <strong>Phone:</strong> +1 (832) 576-0651
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Team;
